<div class="rangebox" *ngIf="uniquePOIs.length > 0">
    <button data-target="#collapsenear" data-toggle="collapse" class="collapsebtn" type="button">
      Near By
    </button>
    <div id="collapsenear" class="collapse show">
      <div class="boxins">
        <ul class="locationul">
          <li *ngFor="let poi of uniquePOIs">
            <div class="squaredThree">
              <input
                type="checkbox"
                name="check"
                class="farecheckbox"
                [id]="'squaredThree' + poi.facilityCode"
                (change)="onPOIChange(poi.poiName, $event.target.checked)"
              />
              <label [for]="'squaredThree' + poi.facilityCode"></label>
            </div>
            <label class="llbl" [for]="'squaredThree' + poi.facilityCode">{{ poi.poiName }}</label>
          </li>
        </ul>
      </div>
    </div>
  </div>
  